import api from "@/api/apiConfig"
import {
  Post
} from './base/baseAjax'
let getCalendar = (param) => {
  return Post({
    url: api.shift.getCalendar,
    bodyParam: param
  })
}
let setState = (param) => {
  return Post({
    url: api.shift.setState,
    bodyParam: param
  })
}

export default {
  getCalendar,setState
}



// WEBPACK FOOTER //
// ./src/services/shift.js